export default __webpack_public_path__ + "static/media/camera.34fe2c6b.svg";